import { Data } from "../models/data";
import { Util } from "../utils/util";
import { AddressValidationResponse, IGetAddressList } from "./address-service.interface";
import { HttpService } from './http-service';
import { IService } from "./service.interface";

export class AddressService implements IService {
    private readonly _http: HttpService;
    private readonly _data: Data;
    private readonly _apiAddressLookup: string;

    constructor(http: HttpService, data: Data, apiAddressLookup: string) {
        this._http = http;
        this._data = data;
        this._apiAddressLookup = apiAddressLookup;
    }

    public httpRequestAsync(method: string, url: string, payload: object | null = null, options?: { showProgress?: boolean, noCache?: boolean }): Promise<Response> {
        const storeKey = this._data.getProperty("StoreInfo")?.storeKey
            ?? this._data.getBrandProperty("StoreInfo").storeKey;

        const timeOffset = this._data.getProperty("TimeOffset")
            ?? this._data.getBrandProperty("TimeOffset");

        const businessStartMinute = this._data.getProperty("Settings")?.BSM
            ?? this._data.getBrandProperty("Settings").BSM;

        let businessDate = new Date().toISOString();
        try {
            businessDate = Util.GetBUSDate(Util.NowStore(timeOffset), timeOffset, businessStartMinute).toISOString();
        } catch { }

        return this._http.request(method, url, payload, storeKey, businessDate, { showProgress: options?.showProgress, noCache: options?.noCache });
    }

    public async getAddressList(payload: IGetAddressList): Promise<{ Addr: any[] }> {
        const response = await this.httpRequestAsync('POST', `${this._apiAddressLookup}/GetStreets`, payload, { showProgress: false, noCache: false });
        const json = response.status === 200 ? await this._http.getJson(response) : null;
        return json ?? { Addr: [] };
    }

    public async validateAddressAsync(address: string, zipCode: string): Promise<AddressValidationResponse> {
        const response = await this.httpRequestAsync('POST', `${this._apiAddressLookup}/address/validate`, { address, zipCode }, { showProgress: false, noCache: false });
        const json = response.ok ? await this._http.getJson(response) : { success: false, valid: false, message: "Server returned an error." };
        return json;
    }
}